import {useEffect, useState} from 'react';
import {useParams, Link} from 'react-router-dom';
import {Button, Col, Row, Spin, Typography} from 'antd';
import {EnrollmentsService} from './EnrollmentsService';
import {EnrichedEnrollment} from './IEnrollmentsService';

const enrollmentsService = new EnrollmentsService();

export const EnrollmentDetails = () => {
  // 4fe2f51f-302e-40d1-ad9a-5d28d8e3fd69
  const [enrollment, setEnrollment] = useState<EnrichedEnrollment | undefined>(
    undefined,
  );
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  let params: {enrollmentId: string} = useParams();

  const {Title, Text} = Typography;

  useEffect(() => {
    enrollmentsService
      .getEnrollmentById(params.enrollmentId)
      .then((resp) => {
        setIsLoading(false);
        setEnrollment(resp);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, []);

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>Enrollment </Title>
      <Button size={'large'} style={{float: 'right'}}>
        <Link
          // @ts-ignore
          to={{
            pathname: '/enrollments/' + enrollment?._id + '/edit',
            state: {enrollment: enrollment},
          }}>
          Edit
        </Link>
      </Button>
      {!isError && !isLoading && (
        <>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Student name
                </Text>
                <Link to={'/students/' + enrollment?.student?.id}>
                  {enrollment?.student?.name}
                </Link>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Started at
                </Text>
                <Text>{enrollment?.startDate}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Placement test status
                </Text>
                <Text>{enrollment?.placementStatus}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Enrollment status
                </Text>
                <Text>{enrollment?.enrollmentStatus}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Is Free
                </Text>
                <Text>{enrollment?.isFree ? 'Yes' : 'No'}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Payment Method
                </Text>
                <Text>{enrollment?.paymentMethod || 'N/A'}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Level
                </Text>
                <Text>{enrollment?.level?.name}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Package
                </Text>
                <Text>{enrollment?.package?.name}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Final Price
                </Text>
                <Text>
                  {enrollment?.finalPrice
                    ? `${enrollment.finalPrice.price} ${enrollment.finalPrice.currency}`
                    : 'N/A'}
                </Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Payment Reference ID
                </Text>
                <Text>{enrollment?.paymentReferenceId || 'N/A'}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Placement Test Answer ID
                </Text>
                <Text>{enrollment?.placementTestAnswerId || 'N/A'}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Curriculum ID
                </Text>
                <Text>{enrollment?.curriculumId || 'N/A'}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Placement test
                </Text>
                {enrollment?.test?.id ? (
                  <Link to={'/placement-tests/' + enrollment.test.id}>
                    {enrollment.test.name || enrollment.test.id}
                  </Link>
                ) : (
                  <Text>N/A</Text>
                )}
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Created By
                </Text>
                <Text>{enrollment?.createdBy || 'N/A'}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Created at
                </Text>
                <Text>{enrollment?.createdAt}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Updated at
                </Text>
                <Text>{enrollment?.updatedAt}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  End Date
                </Text>
                <Text>{enrollment?.endDate || 'N/A'}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Partner ID
                </Text>
                <Text>{enrollment?.partnerId || 'N/A'}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Discount Code
                </Text>
                <Text>
                  {enrollment?.discountCodeId?.code || 'N/A'}
                  {enrollment?.discountCodeId?.value &&
                    ` (${enrollment.discountCodeId.value}${enrollment.discountCodeId.type === 'percentage' ? '%' : ''})`}
                </Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Plan ID
                </Text>
                <Text>{enrollment?.planId || 'N/A'}</Text>
              </div>
            </Col>
          </Row>
        </>
      )}
      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Enrollment fetching error ⚠️</Title>}
    </div>
  );
};
